"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTwapContext = exports.TwapAdapter = exports.Content = exports.getInitialState = exports.TwapContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var types_1 = require("../types");
var en_json_1 = __importDefault(require("../i18n/en.json"));
var react_query_1 = require("@tanstack/react-query");
var analytics_1 = require("../analytics");
var ErrorHandling_1 = require("../ErrorHandling");
var web3_1 = __importDefault(require("web3"));
var query_1 = require("../hooks/query");
var components_1 = require("../components");
var consts_1 = require("../consts");
var utils_1 = require("../utils");
var moment_1 = __importDefault(require("moment"));
var web3_candies_1 = require("@defi.org/web3-candies");
var actions_1 = require("./actions");
analytics_1.analytics.onModuleImported();
exports.TwapContext = (0, react_1.createContext)({});
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
var WrappedTwap = function (props) {
    var _a = (0, exports.useTwapContext)(), srcToken = _a.srcToken, dstToken = _a.dstToken;
    query_1.query.useFeeOnTransfer(srcToken === null || srcToken === void 0 ? void 0 : srcToken.address);
    query_1.query.useFeeOnTransfer(dstToken === null || dstToken === void 0 ? void 0 : dstToken.address);
    query_1.query.useAllowance();
    return (0, jsx_runtime_1.jsx)(ErrorHandling_1.TwapErrorWrapper, { children: props.children });
};
var Listener = function (props) {
    var interval = (0, react_1.useRef)();
    var _a = (0, exports.useTwapContext)(), state = _a.state, updateState = _a.updateState;
    var setCustomDuration = actions_1.stateActions.useSetCustomDuration();
    (0, react_1.useEffect)(function () {
        if (props.isLimitPanel) {
            setCustomDuration({ resolution: types_1.TimeResolution.Days, amount: 7 });
        }
        else {
            setCustomDuration(undefined);
        }
    }, [props.isLimitPanel]);
    (0, react_1.useEffect)(function () {
        if (state.showConfirmation && !state.swapState) {
            updateState({ confirmationClickTimestamp: (0, moment_1.default)() });
            interval.current = setInterval(function () {
                updateState({ confirmationClickTimestamp: (0, moment_1.default)() });
            }, 10000);
        }
        return function () { return clearInterval(interval.current); };
    }, [state.showConfirmation, state.swapState, updateState]);
    (0, react_1.useEffect)(function () {
        analytics_1.analytics.onLibInit(props.config, props.provider, props.account);
    }, [props.config, props.provider, props.account]);
    return null;
};
var getInitialState = function (_a) {
    var _b = _a.storeOverride, storeOverride = _b === void 0 ? {} : _b, isQueryParamsEnabled = _a.isQueryParamsEnabled;
    var tradeIntervalQueryParam = (0, utils_1.getQueryParam)(consts_1.QUERY_PARAMS.TRADE_INTERVAL);
    var srcAmountUi = (0, utils_1.getQueryParam)(consts_1.QUERY_PARAMS.INPUT_AMOUNT);
    var chunks = (0, utils_1.getQueryParam)(consts_1.QUERY_PARAMS.TRADES_AMOUNT);
    return __assign({ srcAmountUi: !isQueryParamsEnabled ? "" : srcAmountUi || "", confirmationClickTimestamp: (0, moment_1.default)(), showConfirmation: false, disclaimerAccepted: true, customChunks: !isQueryParamsEnabled ? undefined : chunks ? Number(chunks) : undefined, customFillDelay: !isQueryParamsEnabled
            ? consts_1.defaultCustomFillDelay
            : { resolution: types_1.TimeResolution.Minutes, amount: tradeIntervalQueryParam ? Number(tradeIntervalQueryParam) : consts_1.MIN_TRADE_INTERVAL_FORMATTED }, isMarketOrder: false, isCustomLimitPrice: !!(0, utils_1.limitPriceFromQueryParams)(), customLimitPrice: (0, utils_1.limitPriceFromQueryParams)(), selectedOrdersTab: 0 }, storeOverride);
};
exports.getInitialState = getInitialState;
var ActionType;
(function (ActionType) {
    ActionType["UPDATED_STATE"] = "UPDATED_STATE";
})(ActionType || (ActionType = {}));
var contextReducer = function (state, action) {
    switch (action.type) {
        case ActionType.UPDATED_STATE:
            return __assign(__assign({}, state), action.value);
        default:
            return state;
    }
};
var useStore = function (props) {
    var _a = (0, react_1.useReducer)(contextReducer, (0, exports.getInitialState)({ storeOverride: props.storeOverride, isQueryParamsEnabled: props.enableQueryParams })), state = _a[0], dispatch = _a[1];
    var updateState = (0, react_1.useCallback)(function (value) { return dispatch({ type: ActionType.UPDATED_STATE, value: value }); }, [dispatch]);
    return {
        updateState: updateState,
        state: state,
    };
};
var useIsWrongChain = function (props, chainId) {
    var _a;
    return (0, react_1.useMemo)(function () {
        var _a;
        if (!props.account) {
            return false;
        }
        if (props.isWrongChain) {
            return true;
        }
        if (!chainId) {
            return false;
        }
        return chainId !== ((_a = props.config) === null || _a === void 0 ? void 0 : _a.chainId);
    }, [chainId, (_a = props.config) === null || _a === void 0 ? void 0 : _a.chainId, props.isWrongChain]);
};
var Content = function (props) {
    var config = props.config;
    var translations = (0, react_1.useMemo)(function () { return (__assign(__assign({}, en_json_1.default), props.translations)); }, [props.translations]);
    var isWrongChain = useIsWrongChain(props, props.chainId);
    var _a = useStore(props), updateState = _a.updateState, state = _a.state;
    var uiPreferences = props.uiPreferences || {};
    var web3 = (0, react_1.useMemo)(function () { return (!props.provider ? undefined : new web3_1.default(props.provider)); }, [props.provider]);
    (0, react_1.useEffect)(function () {
        (0, web3_candies_1.setWeb3Instance)(web3);
    }, [web3]);
    return ((0, jsx_runtime_1.jsxs)(exports.TwapContext.Provider, __assign({ value: {
            translations: translations,
            isWrongChain: isWrongChain,
            state: state,
            updateState: updateState,
            marketPrice: props.marketPrice,
            uiPreferences: uiPreferences,
            srcToken: props.srcToken,
            dstToken: props.dstToken,
            srcUsd: props.srcUsd || 0,
            dstUsd: props.dstUsd || 0,
            Components: props.Components,
            web3: web3,
            config: config,
            account: props.account,
            onDstTokenSelected: props.onDstTokenSelected,
            onSrcTokenSelected: props.onSrcTokenSelected,
            onSwitchTokens: props.onSwitchTokens || (function () { }),
            isLimitPanel: !!props.isLimitPanel,
            tokens: props.parsedTokens,
            maxFeePerGas: props.maxFeePerGas,
            priorityFeePerGas: props.priorityFeePerGas,
            askDataParams: props.askDataParams,
            onTxSubmitted: props.onTxSubmitted,
            minNativeTokenBalance: props.minNativeTokenBalance,
            enableQueryParams: props.enableQueryParams,
            isExactAppoval: props.isExactAppoval,
            fee: props.fee,
        } }, { children: [(0, jsx_runtime_1.jsx)(WrappedTwap, __assign({}, props)), (0, jsx_runtime_1.jsx)(components_1.LimitPriceMessageContent, {}), (0, jsx_runtime_1.jsx)(Listener, __assign({}, props))] })));
};
exports.Content = Content;
var TwapAdapter = function (props) {
    return ((0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, __assign({ client: queryClient }, { children: (0, jsx_runtime_1.jsx)(exports.Content, __assign({}, props)) })));
};
exports.TwapAdapter = TwapAdapter;
var useTwapContext = function () {
    return (0, react_1.useContext)(exports.TwapContext);
};
exports.useTwapContext = useTwapContext;
